import { startTransition } from 'react'
import { View } from 'react-native'
import { Badge } from '~/components/ui/badge'
import { Button, ButtonLabel, ButtonVariant } from '~/components/ui/button.tsx'
import { cn } from '~/lib/utils.ts'

export type PropertyTypeFilterOption = {
  key: string
  label: string
  count?: number
}

type PropertyTypeFilterProps = {
  options: PropertyTypeFilterOption[]
  selected: string
  onChange: (key: string) => void
  className?: string
  optionClassName?: string
  optionVariant?: ButtonVariant
  selectedVariant?: ButtonVariant
  labelClassName?: string
}

export function PropertyTypeFilter({
  options,
  selected,
  onChange,
  optionClassName,
  optionVariant,
  selectedVariant,
  className,
  labelClassName,
}: PropertyTypeFilterProps) {
  return (
    <View className={cn('flex-row flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-x-6', className)}>
      {options.map((option) => {
        const isActive = selected === option.key
        const shouldRenderBadge = option.count !== undefined

        return (
          <Button
            key={option.key}
            variant={isActive ? (selectedVariant ?? 'secondary') : (optionVariant ?? 'ghost')}
            aria-selected={isActive}
            className={cn(
              'relative px-2 aria-selected:mx-2 aria-selected:px-6 sm:px-3 sm:aria-selected:px-6',
              optionClassName
            )}
            size="sm"
            onPress={() => startTransition(() => onChange(option.key))}>
            <ButtonLabel className={labelClassName}>
              {option.label}
              {shouldRenderBadge && (
                <Badge
                  size="xs"
                  variant={isActive ? 'primary' : 'secondary'}
                  textClassName={cn('text-primary', isActive && 'text-accent-foreground')}
                  className={cn(
                    'absolute -right-6 -top-6 h-6 min-w-6 items-center justify-center self-center border-0 px-1 py-0 transition-all duration-150',
                    isActive ? '-right-8' : 'bg-muted'
                  )}>
                  {String(option.count)}
                </Badge>
              )}
            </ButtonLabel>
          </Button>
        )
      })}
    </View>
  )
}
